<!-- <button (click)="handleGoogleLogin()">Login with google</button> -->

<div class="mybtn-cancel" style="background-color: red; color: white;" (click)="handleGoogleLogin()"><i
        class="fa fa-google" style="margin-right: 5px;" aria-hidden="true"></i> google prijava</div>